'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OperationsNumericConstants = exports.OperationsConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OperationsConstants = exports.OperationsConstants = (0, _keymirror2.default)({
    OPERATION_LOAD: null,
    OPERATION_LOAD_SUCCESS: null,
    OPERATION_LOAD_FAIL: null,
    MORE_LOAD: null,
    MORE_LOAD_SUCCESS: null
});

var OperationsNumericConstants = exports.OperationsNumericConstants = {
    OPERATIONS_PAGE_LIMIT: 15
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/operations.js
// module id = 1873
// module chunks = 0